export default "__VITE_ASSET__4fg9XYAL__";